module.exports = __webpack_public_path__ + "img/home_bg_04_1.aa51fe52.png";